import { MarketType } from "../../../types";

export default function isValidPhoneNumber(number: string, market: MarketType) {
  const koreaRegex = /^010\d{8}$/;
  const taiwanRegex = /^09\d{8}$/;
  const hongKongRegex = /^(?:(?:852|853))?\d{8}$/;
  const chinaRegex = /^(?:86)?1\d{10}$/;

  if (market === "TW") return taiwanRegex.test(number);
  if (market === "KR") return koreaRegex.test(number);
  if (market === "HK")
    return hongKongRegex.test(number) || chinaRegex.test(number);

  return false;
}
